module.exports = __webpack_public_path__ + "media/styles/images/svg/comment-teal-4645789949080bf73503b6dc1c54872e.svg";